import {useQuery} from '@apollo/client';
import {CAlert, CCol, CRow} from '@coreui/react-pro';
import React, {lazy, Suspense, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import Loading from '../components/helper/Loading';
import {CENTER_PERMISSIONS} from '../service/apollo/graphQL/queries/center/permissions';
import {CenterType} from '../type/center/center';
import {PermissionType} from '../type/permission';

const Breadcrumb = lazy(() => import('../components/helper/Breadcrumb'));
const CenterInformationCard = lazy(() => import('../components/center/information/Card'));
const CenterMonthSummaryReport = lazy(() => import('../components/center/month-summary-report/Report'));
const CenterAuthorisedUsersCard = lazy(() => import('../components/center/authorised-users/Card'));
const CenterAnnualReportCard = lazy(() => import('../components/center/annual-report/Card'));
const CenterFrequenciesCard = lazy(() => import('../components/center/frequencies/Card'));

export default function CenterPage() {
    const {id} = useParams<{ id : string }>();
    const {loading, error, data} = useQuery<{ center : CenterType }>(CENTER_PERMISSIONS, {variables: {id}});
    const [permissions, setPermissions] = useState<PermissionType>({});
    const [name, setName] = useState<string>('');

    useEffect(() => {
        if (data && data.center) {
            setPermissions(data.center.permissions);
            setName(data.center.name);
        }
    }, [data]);

    return (
        <>
            <Breadcrumb items={[{name: name, active: true}]}/>
            <CRow>
                {loading && <CCol><Loading/></CCol>}
                {error && <CCol><CAlert color="danger">{error.message}</CAlert></CCol>}

                {(!loading && !error && id) &&
                    <>
                        <CCol xl={4}>
                            <Suspense fallback={<></>}>
                                <CenterInformationCard id={id} permissions={permissions}/>
                            </Suspense>
                            <Suspense fallback={<></>}>
                                <CenterAnnualReportCard permissions={permissions} id={id}/>
                            </Suspense>
                        </CCol>
                        <CCol>
                            <CRow>
                                <CCol>
                                    <Suspense fallback={<></>}>
                                        <CenterMonthSummaryReport id={id} permissions={permissions}/>
                                    </Suspense>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol xl={6}>
                                    <Suspense fallback={<></>}>
                                        <CenterAuthorisedUsersCard id={id} name={name} permissions={permissions}/>
                                    </Suspense>
                                </CCol>
                                <CCol xl={6}>
                                    <Suspense fallback={<></>}>
                                        <CenterFrequenciesCard id={id} permissions={permissions}/>
                                    </Suspense>
                                </CCol>
                            </CRow>
                        </CCol>
                    </>
                }
            </CRow>
        </>
    );
};
